module.exports = __webpack_public_path__ + "img/user-white.edcbec5d.svg";